var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.674,
    height: 64.674,
    viewBox: "0 0 60.674 64.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 60.674,
    height: 64.674,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_182",
    "data-name": "Mask Group 182",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M30.247,16.434a2.521,2.521,0,1,1-2.521,2.52,2.521,2.521,0,0,1,2.521-2.52",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M52.932,39.119v.3a10.663,10.663,0,0,0-4.033-.806,9.518,9.518,0,0,0-5.747,1.815H7.663v-.1L25.206,26.617l3.831,7.562,10.082-12.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M52.931,7.562V39.12L39.119,21.476l-10.082,12.6L25.2,26.517,7.662,40.228V7.562ZM32.767,18.955a2.52,2.52,0,1,0-2.521,2.521,2.561,2.561,0,0,0,2.521-2.521",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M59.283,1.311V48.9a9.177,9.177,0,0,0-.3-2.319,10.459,10.459,0,0,0-6.05-7.259V7.562H7.662V40.329H43.051a10.562,10.562,0,0,0-4.335,6.352H1.311V1.311Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M7.562,41.64a1.4,1.4,0,0,1-1.009-.5,1.4,1.4,0,0,1,.2-1.815l.1-.1L24.4,25.509a1.242,1.242,0,0,1,1.009-.2.976.976,0,0,1,.806.706l2.924,5.847,8.872-11.09a1.241,1.241,0,0,1,1.009-.505,1.4,1.4,0,0,1,1.008.505L53.939,38.313a1.291,1.291,0,1,1-2.016,1.613l-12.9-16.434L29.944,34.885a1.623,1.623,0,0,1-1.11.5,1.214,1.214,0,0,1-1.007-.706L24.7,28.533,8.368,41.337a1.338,1.338,0,0,1-.806.3",
    fill: "#001c34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M30.247,22.685a3.831,3.831,0,1,1,3.831-3.831,3.829,3.829,0,0,1-3.831,3.831m0-5.041a1.311,1.311,0,1,0,1.311,1.311,1.335,1.335,0,0,0-1.311-1.311",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M59.283,50.411A1.335,1.335,0,0,1,57.972,49.1V2.52H2.52V45.37h32.3a1.311,1.311,0,1,1,0,2.621H1.311A1.335,1.335,0,0,1,0,46.681V1.311A1.335,1.335,0,0,1,1.311,0H59.283a1.335,1.335,0,0,1,1.311,1.311V49.2a1.5,1.5,0,0,1-1.311,1.21",
    fill: "#001c34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M40.152,41.64H7.663a1.335,1.335,0,0,1-1.311-1.311V7.562A1.335,1.335,0,0,1,7.663,6.251H52.932a1.335,1.335,0,0,1,1.31,1.311v31.86a1.311,1.311,0,1,1-2.621,0V8.873H8.973V39.119H40.152a1.335,1.335,0,0,1,1.311,1.311,1.25,1.25,0,0,1-1.311,1.21",
    fill: "#001c34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M58.889,48.371a10.143,10.143,0,0,1,.357,2.737,12.2,12.2,0,1,1-24.395-.119,10.8,10.8,0,0,1,.357-2.737,12.319,12.319,0,0,1,5.117-7.5,12.079,12.079,0,0,1,6.783-2.142,12.58,12.58,0,0,1,4.76.952,12.879,12.879,0,0,1,7.021,8.806",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M46.989,64.674A13.764,13.764,0,0,1,33.3,50.989a12.708,12.708,0,0,1,.357-2.975,12.926,12.926,0,0,1,5.712-8.33,13.587,13.587,0,0,1,12.97-1.309,13.629,13.629,0,0,1,7.974,9.639,12.707,12.707,0,0,1,.356,2.975A13.763,13.763,0,0,1,46.989,64.674m0-24.4a10.71,10.71,0,0,0-10.472,8.33,16.127,16.127,0,0,0-.238,2.38,10.71,10.71,0,1,0,21.42,0,16.127,16.127,0,0,0-.238-2.38,10.555,10.555,0,0,0-6.307-7.5,10.025,10.025,0,0,0-4.165-.833",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M47.346,58.724A1.575,1.575,0,0,1,45.8,57.177V43.849a1.547,1.547,0,0,1,3.094,0V57.3a1.765,1.765,0,0,1-1.547,1.428",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M51.749,50.346a1.465,1.465,0,0,1-1.19-.6l-3.332-4.4-3.332,4.4a1.536,1.536,0,1,1-2.5-1.785l4.522-5.95a1.488,1.488,0,0,1,2.38,0l4.522,5.95a1.54,1.54,0,0,1-.357,2.142,1.006,1.006,0,0,1-.714.238",
    fill: "#1e81ce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.fb741b30c6fcc8ccd50802196d054f75.svg";
export { ForwardRef as ReactComponent };